import { useMutation, useQueryClient } from '@tanstack/react-query'
import { bomCapturaApi } from '@/services/api'
import type { BOMCompleto, BOMLinea } from '@/types/bomCaptura'

type BomCache = { data?: BOMCompleto } | undefined

/** Reordenación de líneas de componente → PATCH mserp_positionnumber en F&O. */
export function useLineas(itemId: string, empresa: string, formula: string) {
  const qc = useQueryClient()
  const key = ['bom', itemId, empresa, formula]

  /** Reasigna posiciones 10,20,30… según el nuevo orden y PATCHea las que cambiaron.
   *  Optimista: aplica el orden en la caché al instante y no invalida (evita que el
   *  refetch —con la posición aún sin propagar en F&O— revierta el cambio). */
  const reorder = useMutation({
    mutationFn: async (ordenadas: BOMLinea[]) => {
      await Promise.all(
        ordenadas.map((l, i) => {
          const pos = (i + 1) * 10
          return l.positionNumber === pos
            ? Promise.resolve()
            : bomCapturaApi.setLineaPosicion(itemId, empresa, formula, l.id, pos)
        }),
      )
    },
    onMutate: async (ordenadas: BOMLinea[]) => {
      await qc.cancelQueries({ queryKey: key })
      const prev = qc.getQueryData<BomCache>(key)
      qc.setQueryData<BomCache>(key, (old) => {
        if (!old?.data) return old
        const lineas = ordenadas.map((l, i) => ({ ...l, positionNumber: (i + 1) * 10 }))
        return { ...old, data: { ...old.data, lineas } }
      })
      return { prev }
    },
    onError: (_e, _vars, ctx) => {
      if (ctx?.prev !== undefined) qc.setQueryData(key, ctx.prev)
    },
  })

  return { reorder }
}
